import React from "react";

export default function CouponBanner() {
  return (
    <div className="coupon-top-banner py-1 text-white text-center shadow-sm">
      <div className="container">
        <span className="small fw-semibold ls-1">
          Get 10% Off on Orders Above Rs. 1000 - Use Code:{" "}
          <span className="py-1 ms-1 fs-6 fw-bold text-white">A1BAK1025</span>
        </span>
      </div>
    </div>
  );
}
